module.exports = __webpack_public_path__ + "static/media/arrows-alt.7c551c1a.svg";